var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3,199.7c-2.3,0-4.2-1.9-4.2-4.2v-17.9c0-2.3,1.9-4.2,4.2-4.2h45.7l-35.3-47.1c-2,0.7-4,1.1-6.1,1.1 c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2c2.3,0,4.6,0.5,6.8,1.4l35.8-36.1L58.6,47.7c-2.2-2.2-3.4-5.1-3.4-8.2 c0-3.1,1.2-6,3.4-8.2L85.4,4.4C87.6,2.2,90.6,1,93.6,1c1,0,2,0.1,3,0.4c2,0.5,3.8,1.6,5.2,3l28.1,27.9l54,18.1l3.9,1.1 c2.4,0.6,4.3,2.5,4.9,4.9c0.7,2.4,0,5-1.8,6.7L176.2,78c6,7.9,8.1,18.2,5.5,27.7c-3.7,13.9-16.4,23.7-30.9,23.7 c-2.8,0-5.6-0.4-8.3-1.1c-4-1.1-7.8-2.9-11.2-5.5l-13.9,13.9c-1.3,1.3-3.1,2-4.9,2c-0.6,0-1.2-0.1-1.8-0.2c-2.5-0.7-4.4-2.6-5-5.1 l-1-3.8L86.7,75.7L75.2,64.2l-35,35.3c2.4,3,3.8,6.8,3.8,10.7c0,4.2-1.5,8.2-4.3,11.3l38.9,51.9h49.8c2.3,0,4.2,1.9,4.2,4.2v17.9 c0,2.3-1.9,4.2-4.2,4.2H22.3z M124.1,191.4v-9.6H26.5v9.6H124.1z M112.7,127c0,0.1,0,0.1,0.1,0.2l0.5,1.9L183.4,59l-2-0.6 l-52.9-17.8L95.1,74.5L112.7,127z M137.4,116.8c2.3,1.6,4.7,2.7,7.4,3.4c2,0.5,4.1,0.8,6.1,0.8c10.7,0,20.1-7.2,22.8-17.5 c1.8-6.6,0.5-13.9-3.5-19.6L137.4,116.8z M26.7,101.3c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C35.6,105.3,31.6,101.3,26.7,101.3z M93.6,9.3c-0.9,0-1.7,0.3-2.3,1L64.5,37.1c-0.6,0.6-1,1.5-1,2.3c0,0.9,0.3,1.7,1,2.4l13.4,13.3 c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.2l11.9,11.9l31.3-31.7L96,10.3c-0.4-0.4-0.9-0.7-1.5-0.9 C94.2,9.4,93.9,9.3,93.6,9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.da636ab8e418645619d9b10d12f0eee8.svg";
export { ForwardRef as ReactComponent };